/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import ToolsMenu from '../../../../modules/twh/components/tools/ToolsMenu'
import UserMenu from './UserMenu'
import { ActionIcon, Group, GroupProps } from '@mantine/core'
import CreateMenu from '../../../../modules/twh/components/CreateMenu'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus'
import { useIntl } from 'react-intl'

export type AdminHeaderProps = GroupProps

function AdminHeader (props: AdminHeaderProps) {
  const { children, ...others } = props
  const intl = useIntl()
  return (
    <Group
      h="100%"
      px="md"
      align="center"
      {...others}
    >
      {children}

      <Group gap="xs" ml="auto">
        <CreateMenu>
          <ActionIcon
            variant="subtle"
            radius="xl"
            size="lg"
            title={intl.formatMessage({ id: 'new' })}
          >
            <FontAwesomeIcon fixedWidth icon={faPlus} />
          </ActionIcon>
        </CreateMenu>
        <ToolsMenu />
        <UserMenu />
      </Group>
    </Group>
  )
}

export default AdminHeader
